<template>
    <div class="flexy">
        <section class="hero">
            <div class="hero-body">
                <div class="level">
                    <div class="level-left">
                        <h1 class="title">Setari</h1>
                    </div>
                    <div  class="level-right is-hidden">
                        <button class="button is-primary" @click="add">
                            <span class="icon is-small">
                                <i class="fa fa-plus-circle"></i>
                            </span>
                            <span>Adauga</span>
                        </button>
                    </div>
                </div>
                <hr class="is-hidden-mobile" />
            </div>
        </section>
        <div class="has-text-centered">
            <b-field class="is-pulled-right is-clearfix  is-hidden">
                <b-input
                    placeholder="nume sau prenume ..."
                    type="input"
                    icon="magnify"
                    v-model="query"
                    @keyup.native.enter="search"
                ></b-input>
                <p class="control">
                    <button
                        class="button is-primary is-outlined"
                        size="is-large"
                        @click="search"
                    >
                        Cauta
                    </button>
                </p>
            </b-field>

            <div class="is-clearfix"></div>

            <loading-info />

            <!--Price plans-->
            
            <!--Price plans-->
            
            
            <!--<b-notification-->
            <!--    type="is-info"-->
            <!--    has-icon-->
            <!--    :closable="false"-->
            <!--    aria-close-label="Close notification">-->
            <!--    <h1 class="is-size-5 has-text-centered ">In curand ...</h1>-->
            <!--    </b-notification>-->

            <!-- Push Notifications Settings -->
            <div class="box has-background-white-bis mb-5">
                <h2 class="is-size-5 has-text-weight-semibold mb-4">
                    <b-icon icon="bell" class="mr-2"></b-icon>
                    Notificări Push
                </h2>
                
                <div v-if="!pushSupported" class="notification is-warning is-light">
                    <p>Notificările push nu sunt suportate pe acest dispozitiv/browser.</p>
                </div>
                
                <div v-else>
                    <div class="field">
                        <b-switch 
                            v-model="pushEnabled" 
                            @input="handlePushToggle"
                            :disabled="pushLoading"
                        >
                            {{ pushEnabled ? 'Activate' : 'Dezactivate' }}
                        </b-switch>
                    </div>
                    
                    <div class="content is-small">
                        <p class="has-text-grey">
                            <b-icon icon="information" size="is-small" class="mr-1"></b-icon>
                            <template v-if="isIOS && !isInstalled">
                                <strong>iOS:</strong> Pentru notificări, adaugă aplicația pe ecranul principal:
                                apasă <b-icon icon="export-variant" size="is-small"></b-icon> și apoi "Add to Home Screen".
                            </template>
                            <template v-else>
                                Primești notificări instant despre documente care expiră.
                            </template>
                        </p>
                        
                        <p v-if="pushPermissionBlocked" class="has-text-danger">
                            <b-icon icon="alert-circle" size="is-small" class="mr-1"></b-icon>
                            Notificările sunt blocate. Activează-le din setările browserului.
                        </p>
                    </div>
                    
                    <div v-if="pushEnabled" class="field mt-4">
                        <b-button 
                            size="is-small" 
                            type="is-info is-outlined"
                            @click="sendTestNotification"
                            :loading="testLoading"
                        >
                            Trimite notificare test
                        </b-button>
                    </div>
                </div>
            </div>

            <div class="table-container is-hidden" v-show="!isLoading">
                <b-table
                    :data="servicesList"
                    :row-class="
                        (row, index) =>
                            row.isExpired &&
                            'has-background-danger has-text-white	'
                    "
                    :bordered="true"
                    :striped="true"
                    :narrowed="false"
                    :hoverable="true"
                >
                    <template slot-scope="props" bordered>
                        <b-table-column
                            field="name"
                            width="130"
                            label="Service"
                            >{{ props.row.name }}</b-table-column
                        >
                        <b-table-column
                            field="vehicleName"
                            width="130"
                            label="Nr. auto"
                            >{{ props.row.vehicleName }}</b-table-column
                        >
                        <b-table-column field="date" width="130" label="Data">{{
                            props.row.date
                        }}</b-table-column>
                        <b-table-column field="date" width="130" label="Km">{{
                            props.row.kms | nbr
                        }}</b-table-column>

                        <!-- <b-table-column field="comments" label="Observatii">{{ props.row.comments }}</b-table-column> -->
                        <b-table-column label :centered="true" width="160">
                            <button
                                class="button is-small is-rounded"
                                @click="edit(props.row)"
                            >
                                <span class="icon is-small">
                                    <i class="fa fa-edit"></i>
                                </span>
                            </button>
                            <button
                                class="button is-small is-rounded"
                                @click="del(props.row)"
                            >
                                <span class="icon is-small has-text-danger">
                                    <i class="fa fa-trash"></i>
                                </span>
                            </button>
                        </b-table-column>
                    </template>
                    <template #empty>
                        <div class="has-text-centered">
                            <h1 class="is-size-5">
                                Nu am gasit nici o inregistrare.
                            </h1>
                            <div>
                                <button class="button is-text" @click="add">
                                    Adauga o inregistrare noua
                                </button>
                            </div>
                        </div>
                    </template>
                </b-table>
            </div>

            <b-pagination
                v-show="!isLoading && servicesList.length > 0"
                :total="services.total"
                :current.sync="page"
                :simple="false"
                :rounded="false"
                :per-page="services.perPage"
                @change="doPaginate"
            >
            </b-pagination>
        </div>
    </div>
</template>

<script>
import Form from "@/components/ServiceForm";
import LoadingInfo from "@/components/LoadingInfo";
import pushNotificationService from "@/services/pushNotificationService";

import { mapGetters, mapActions, mapState } from "vuex";

export default {
    name: "drivers",
    components: { LoadingInfo },
    data() {
        return {
            page: 1,
            query: "",
            pushSupported: false,
            pushEnabled: false,
            pushLoading: false,
            testLoading: false,
            pushPermissionBlocked: false,
            isIOS: false,
            isInstalled: false
        };
    },
    computed: {
        ...mapGetters(["isLoading"]),
        ...mapState(["services"]),
        servicesList() {
            return this.services.items || [];
        },
    },
    async mounted() {
        // Check push notification support and status
        this.pushSupported = pushNotificationService.isPushSupported();
        this.isIOS = pushNotificationService.isIOS();
        this.isInstalled = pushNotificationService.isInstalled();
        
        if (this.pushSupported) {
            this.pushEnabled = await pushNotificationService.isSubscribed();
            const permission = pushNotificationService.getPermissionState();
            this.pushPermissionBlocked = permission === 'denied';
        }
    },

    methods: {
        ...mapActions(["loadServices", "delService"]),
        search() {
            this.page = 1;
            this.doPaginate();
        },
        add: function () {
            this.$modal.open({
                parent: this,
                component: Form,
                hasModalCard: true,
                canCancel: false,
                props: { reload: this.doPaginate },
            });
        },
        del(f) {
            this.$buefy.dialog.confirm({
                message: `Sigur stergem inregistrarea: <b> ${f.name}</b> ?`,
                onConfirm: () => {
                    this.delService(f.id)
                        .then(() => {
                            this.doPaginate();
                            this.$buefy.toast.open("Service sters!");
                        })
                        .catch((err) => console.log(err));
                },
            });
        },
        edit: function (f) {
            this.$modal.open({
                parent: this,
                component: Form,
                hasModalCard: true,
                canCancel: false,
                props: { serviceId: f.id, reload: this.doPaginate },
            });
        },
        doPaginate(page) {
            page = page || 1;
            this.loadServices({ page: page, query: this.query });
        },
        async handlePushToggle(enabled) {
            this.pushLoading = true;
            try {
                if (enabled) {
                    await pushNotificationService.subscribeToPush();
                    this.$buefy.toast.open({
                        message: 'Notificări activate cu succes!',
                        type: 'is-success',
                        duration: 3000
                    });
                    this.pushPermissionBlocked = false;
                } else {
                    await pushNotificationService.unsubscribeFromPush();
                    this.$buefy.toast.open({
                        message: 'Notificări dezactivate',
                        type: 'is-info',
                        duration: 3000
                    });
                }
            } catch (error) {
                console.error('Error toggling push notifications:', error);
                this.pushEnabled = !enabled; // Revert toggle
                
                let errorMessage = 'Nu am putut schimba setările notificărilor.';
                if (error.message.includes('denied')) {
                    errorMessage = 'Ai blocat notificările. Activează-le din setările browserului.';
                    this.pushPermissionBlocked = true;
                }
                
                this.$buefy.toast.open({
                    message: errorMessage,
                    type: 'is-danger',
                    duration: 5000
                });
            } finally {
                this.pushLoading = false;
            }
        },
        async sendTestNotification() {
            this.testLoading = true;
            try {
                const result = await pushNotificationService.sendTestNotification();
                this.$buefy.toast.open({
                    message: `Notificare trimisă! (${result.sent}/${result.total})`,
                    type: 'is-success',
                    duration: 3000
                });
            } catch (error) {
                console.error('Error sending test notification:', error);
                
                let errorMessage = 'Nu am putut trimite notificarea test.';
                
                if (error.message && error.message.includes('404')) {
                    errorMessage = 'Nu ești înregistrat pentru notificări. Activează mai întâi notificările.';
                } else if (error.message && error.message.includes('401')) {
                    errorMessage = 'Nu ești autentificat. Reîncearcă după autentificare.';
                }
                
                this.$buefy.toast.open({
                    message: errorMessage,
                    type: 'is-danger',
                    duration: 5000
                });
            } finally {
                this.testLoading = false;
            }
        }
    },
    created() {
       // this.doPaginate();
        // this.loadInsurances();
    },
};
</script>
